import { PSS_LOCAL_STORAGE_KEY } from 'containers/PostSampleSurveyBanner/constants'
import { differenceInHours } from 'date-fns'
import isFromSurveyLocationUtil from 'utils/location/is-from-survey'
import logUtil from 'utils/log'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'
import shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil from 'modules/post-sample-survey/redux/utils/should-show-modal-or-banner-based-on-location'

const MIN_HOURS_TO_SHOW_BANNER = 2

/**
 * @param props
 * @param props.reminder
 * @param props.isInGiftingMode
 * @param props.isGiftOrSelfGiftingUrl
 * @param props.isHomeUrl
 * @param props.isMixedCollectionUrl
 * @param props.hasOngoingDeals
 * @param props.shouldShowUnlockedExtraFreeSamplesBanner
 * @param props.shouldShowSpendMoreToUnlockExtraFreeSamplesBanner
 * @param props.isCartReady
 * @returns {boolean}
 */
export default function shouldShowBannerPostSampleSurveySelectUtil ({
  isCartReady,
  reminder,
  isInGiftingMode,
  isGiftOrSelfGiftingUrl,
  isHomeUrl,
  isMixedCollectionUrl,
  hasOngoingDeals,
  shouldShowUnlockedExtraFreeSamplesBanner,
  shouldShowSpendMoreToUnlockExtraFreeSamplesBanner
}) {
  if (shouldShowSpendMoreToUnlockExtraFreeSamplesBanner) {
    return false
  }

  if (!isCartReady) {
    return false
  }

  if (shouldShowUnlockedExtraFreeSamplesBanner) {
    return false
  }

  if (
    hasOngoingDeals &&
    isHomeUrl
  ) {
    return false
  }

  if (isMixedCollectionUrl) {
    return false
  }

  if (isGiftOrSelfGiftingUrl) {
    return false
  }

  const closedAt = getItemLocalStorageUtil(PSS_LOCAL_STORAGE_KEY.SURVEY_BANNER_CLOSED_AT)
  const localId = getItemLocalStorageUtil(PSS_LOCAL_STORAGE_KEY.SURVEY_BANNER_ID)
  const localSurveyAnswerStatus = getItemLocalStorageUtil(PSS_LOCAL_STORAGE_KEY.SURVEY_BANNER_ANSWER_STATUS)
  const id = reminder?.id
  const surveyAnswerStatus = reminder?.survey_answer_status

  let shouldShow
  let diff
  if (closedAt) {
    diff = differenceInHours(new Date(), new Date(closedAt))
  }

  if (
    !isInGiftingMode &&
    shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil() &&
    reminder && (
      isFromSurveyLocationUtil() ||
      (
        diff == null ||
        diff >= MIN_HOURS_TO_SHOW_BANNER
      ) ||
      (
        id &&
        localId &&
        id !== localId
      ) || (
        surveyAnswerStatus &&
        localSurveyAnswerStatus &&
        surveyAnswerStatus !== localSurveyAnswerStatus
      )
    )
  ) {
    shouldShow = true
  }

  const debugProps = {
    isInGiftingMode,
    closedAt,
    localId,
    id,
    localSurveyAnswerStatus,
    surveyAnswerStatus,
    diff,
    shouldShow
  }
  logUtil('shouldShowBannerPostSampleSurveyUtil').debug('debugProps=', debugProps)

  return shouldShow
}
